"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const underline_1 = __importDefault(require("../../../components/underline"));
require("./SectionTestimonials.scss");
const testimonialsContent_1 = __importDefault(require("./testimonialsContent"));
const SectionTestimonials = () => {
    const refCarousel = (0, react_1.createRef)();
    const next = () => {
        refCarousel.current && refCarousel.current.next();
    };
    const previous = () => {
        refCarousel.current && refCarousel.current.prev();
    };
    return (react_1.default.createElement("div", { className: "SectionTestimonials" },
        react_1.default.createElement("div", { className: "TestimonialTitle" },
            react_1.default.createElement("div", { className: "Testimonials" }, "Depoimentos"),
            react_1.default.createElement(underline_1.default, null)),
        react_1.default.createElement("div", { className: "TestimonialDescription" },
            react_1.default.createElement(icons_1.LeftOutlined, { onClick: () => previous() }),
            react_1.default.createElement("div", { className: "TestimonialContainer" },
                react_1.default.createElement(antd_1.Carousel, { style: { overflow: 'hidden' }, ref: refCarousel, draggable: true, dotPosition: "bottom" }, testimonialsContent_1.default.map(ts => (react_1.default.createElement("div", { key: ts.id },
                    react_1.default.createElement("div", { className: "Testimonial" },
                        react_1.default.createElement("div", { className: "description noselect" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("p", null, ts.description)))),
                    react_1.default.createElement("div", { className: "customerDetails" },
                        react_1.default.createElement("div", { className: "imageCustomer" },
                            react_1.default.createElement("div", { className: "surroundImage", style: { backgroundImage: `url(${ts.witnessImage})` } })),
                        react_1.default.createElement("div", { className: "customerName noselect" },
                            react_1.default.createElement("p", null, ts.witnessName)))))))),
            react_1.default.createElement(icons_1.RightOutlined, { type: "left-circle", onClick: next }))));
};
exports.default = SectionTestimonials;
